import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CashProcessingBatchSearchRequest from "../CashProcessingBatchSearchRequest";
import ModelProxyClass from "./ModelProxyClass";
import ResultParameter from "../ResultParameter";


/**
 * @class CashProcessingBatchSearchRequestBase
 * @extends ModelBaseClass
 * @property {number} vaultId (int64)
 * @property {boolean} includeInProcess by default, this will only return completed batches.  Set this to true to include the in process one (if one exists).
 * @property {ResultParameter} resultParameter [Date]
 */
class CashProcessingBatchSearchRequestBase extends ModelBaseClass {
	/**
	 * @type {number} vaultId (int64)
	 */
	vaultId;
	/**
	 * by default, this will only return completed batches.  Set this to true to include the in process one (if one exists).
	 * @type {boolean} includeInProcess
	 */
	includeInProcess;
	/**
	 * [Date]
	 * @type {ResultParameter} resultParameter
	 */
	resultParameter;

	/**
	 * Instantiates a new instance of CashProcessingBatchSearchRequest based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CashProcessingBatchSearchRequest}
	 */
	static create(genericObject) {
		const newCashProcessingBatchSearchRequest = new CashProcessingBatchSearchRequest();
		newCashProcessingBatchSearchRequest.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCashProcessingBatchSearchRequest;
	}

	/**
	 * Instantiates a new array of CashProcessingBatchSearchRequest based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CashProcessingBatchSearchRequest]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCashProcessingBatchSearchRequestArray = [];
		genericArray.forEach(genericObject => {
			newCashProcessingBatchSearchRequestArray.push(CashProcessingBatchSearchRequest.create(genericObject));
		});
		return newCashProcessingBatchSearchRequestArray;
	}
}

/**
 * @type {string} OrderByDate
 */
CashProcessingBatchSearchRequestBase.OrderByDate = 'date';

const _modelDefinition = [
	ModelBaseClass.createModelProperty('vaultId', 'integer'),
	ModelBaseClass.createModelProperty('includeInProcess', 'boolean'),
	ModelBaseClass.createModelProperty('resultParameter', 'ResultParameter'),
];

export default CashProcessingBatchSearchRequestBase;
